<template lang="pug">
  - $image_path = '@/assets/images/game/pause/';
  .view-pause
    .view-pause-frame
      h2.view-pause-title: img(src=`${$image_path}title.png`)
      button.view-pause-resume(@click="$emit('resume'); playSound('se_click_button');")
        img(src=`${$image_path}button_resume.png`)
      router-link.view-pause-top(:to="{ name:'top' }" @click.native="playSound('se_click_button')")
        img(src=`${$image_path}button_top.png`)
</template>

<script>
import SoundController from '@/assets/js/SoundController';

export default {
  name: 'Pause',
  methods: {
    playSound(key) {
      SoundController.play(key);
    }
  }
};
</script>

<style scoped lang="scss">
.view-pause {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background-color: rgba(62, 191, 241, 0.8);
  &-frame {
    width: vw(1138);
    height: vw(822);
    margin: 0 auto;
    background: image-url('game/pause/image_frame.png') no-repeat center;
    background-size: contain;
  }
  &-title {
    width: vw(354);
    margin: vw(150) auto 0;
  }
  &-resume {
    display: block;
    width: vw(816);
    margin: vw(115) auto 0;
  }
  &-top {
    display: block;
    width: vw(816);
    margin: vw(45) auto 0;
  }
}
</style>
